module.exports = __webpack_public_path__ + "static/media/bi_emblem_black.ee614e48.png";